import { render, staticRenderFns } from "./tradeConfigRecord.vue?vue&type=template&id=6516cc22"
import script from "./tradeConfigRecord.vue?vue&type=script&lang=js"
export * from "./tradeConfigRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports